import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { DocsAccordionItem } from 'routes/essential-workspace/components/quote-panel/collapse/docs-item';
import { QuoteAccordionItem } from 'routes/essential-workspace/components/quote-panel/collapse/quote-item';
import { CollapseKey } from 'routes/essential-workspace/components/quote-panel/collapse/types';

export function QuotePanelCollapse() {
  const [activeKey, setActiveKey] = useState<CollapseKey>('quotes');

  const isSummary = activeKey !== 'quotes';
  const isDocOpen = activeKey === 'documents';

  return (
    <Accordion
      activeKey={activeKey}
      onSelect={key => setActiveKey(key as CollapseKey)}
      className="flex-y gap-3 essential-accordion"
      flush
    >
      <QuoteAccordionItem eventKey="quotes" isSummary={isSummary} />
      <DocsAccordionItem eventKey="documents" canShowError={isDocOpen} />
    </Accordion>
  );
}
